import { useQuery } from "@tanstack/react-query";
import { ApiGetUserDynamicRewardInfo } from "@/api";
import type { GetUserDynamicRewardInfoResponse } from "@/api/types";

export function useUserDynamicRewardInfo(
  type: 1 | 2 | 3,
  coinContract?: string
) {
  return useQuery({
    queryKey: ["userDynamicRewardInfo", type, coinContract ?? ""],
    queryFn: async (): Promise<GetUserDynamicRewardInfoResponse> => {
      const res = await ApiGetUserDynamicRewardInfo({ type, coinContract });
      console.log("useUserDynamicRewardInfo", res.data);
      return res.data;
    },
  });
}
